import React from "react";

import { useState, useEffect } from "react";
import Login from "./Login";

import TitleWithDropdown from "./TitleWithDropdown";

import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import image from "../logos/screenuser.png";
import "./CommonDashboard.css";
import { setCurrentEmms } from "../redux/slices/currentEmmsSlice";
import { setEmmsHeaders, setEmmsLogout } from "../redux/slices/emmsAuthSlice";

import MyScreenuserForm from "./MyScreenuserForm";
import Screenuser from "./Screenuser";
import { setScreenuser } from "../redux/slices/screenusersSlice";
import { setEmmConfig, setEmmScreenuserIds } from "../redux/slices/emmScreenuserSlice";
import BulkRefresh from "./BulkRefresh";
import { setLocation } from "../redux/slices/locationSlice";
import { setCustomisation } from "../redux/slices/customisationSlice";
import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import { mergeAndJoinFields } from "../utils/mergeAndJoinFields";

function ScreenuserDashboard() {
  const api = localStorage.getItem("api");
  const dispatch = useDispatch();
  const emms = useSelector((state) => state.emms);
  const [login, setLogin] = useState(false);
  let selectedEmms = null;
  const [responseData, setResponseData] = useState(null);
  const headers = useSelector((state) => state.header);
  const [resp, setResp] = useState(true);
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const oldLocationData = useSelector((state) => state.location);
  const emmsheaders = useSelector((state) => state?.emmsheaders);
  const selectedRows = useSelector(
    (state) => state?.emmConfig?.emmScreenuserIds || []
  );

  const [selectedOption, setSelectedOption] = useState(emms?.emms?.[0]?.id);
 
  const getData = async (emmsheaders) => {
      const requestBody1 = {
        path: "location",
        query: {},
        emmsId: `${selectedOption}`,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      const requestBody2 = {
        path: "customisation",
        query: {},
        emmsId: `${selectedOption}`,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      const requestBody3 = {
        path: "meetingspace",
        query: {},
        emmsId: `${selectedOption}`,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      const request1 = axios.post(api + `/emms/piggyback`, requestBody1, headers);
      const request2 = axios.post(api + `/emms/piggyback`, requestBody2, headers);
      const request3 = axios.post(api + `/emms/piggyback`, requestBody3, headers);

      try {
        const [response1, response2, response3] = await Promise.all([
          request1,
          request2,
          request3,
        ]);

        dispatch(setLocation(response1.data));
        dispatch(setCustomisation(response2.data));
        dispatch(setMeetingSpaces(response3.data));

        return {
          location: response1.data,
          customisation: response2.data,
          meetingSpaces: response3.data,
        };
      } catch (error) {
        console.error(error);
        return {
          location: [],
          customisation: [],
          meetingSpaces: [],
        };
      }
    };

 async function fetchData(value) {
   setIsLoading(true);
    let selectedEmms = emms?.emms?.find((element) => element.id === value);
    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };
      dispatch(setEmmsHeaders(emmsheaders));
      const supporingData=await getData(emmsheaders)
     

      const requestBody = {
        path: "screenusers",
        query: {  },
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {

          
          const input = {
            baseTable: response?.data || [],
            joins: [
              {
                joinTable: supporingData?.customisation || [],
                correlation: ["customisationId", "id"],
                fields: [
                  {
                    name: "customisation_name",
                    fieldsToJoin: ["name"]
                  }
                ],
                separator: ""
              },
              {
                joinTable: supporingData?.meetingSpaces || [],
                correlation: ["meetingRoomId", "id"],
                fields: [
                  {
                    name: "meeting_room_name",
                    fieldsToJoin: ["name"]
                  }
                ],
                separator: ""
              },
              {
                joinTable: supporingData?.location || [],
                correlation: ["locationId", "id"],
                fields: [
                  {
                    name: "location_name",
                    fieldsToJoin: ["city","building",'floor']
                  }
                ],
                separator: ", "
              },

            ]
          };

          const result = mergeAndJoinFields(input);
    
          dispatch(setScreenuser(result));
          setResponseData(response.data);
          setErrors(false);
        })
        .catch((error) => {
          console.error(error);
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }
  function fetchConfiguredScreenuserIdsData(value) {
    let selectedEmms = emms?.emms?.find((element) => element.id === value);
    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      const requestBody = {
        path: "emm",
        query: {  },
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          dispatch(setEmmConfig(response?.data));
          const screenUserIds = Object.keys(response.data).filter((key) => key !== "url" && !key.includes("mqtt"));
          dispatch(setEmmScreenuserIds(screenUserIds));
        })
        .catch((error) => {
          console.error(error);
        
        });
    }
  }
  useEffect(() => {
    fetchData(selectedOption);
    fetchConfiguredScreenuserIdsData(selectedOption);
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    fetchData(event.target.value);
  };

  const options = emms?.emms?.map((emm) => ({
    label: emm.name,
    value: emm.id,
  }));

  return login == null ? (
    <Login />
  ) : (
    <>
      <div className="mainContainer emms-main-container">
        <header  className="no-margin">
          <figure>
            <img className="img" src={image} alt="Logo" />
          </figure>
        </header>
        <div className="title-container">
          <div className="title">
            <TitleWithDropdown
              title="EMMS Service"
              options={options}
              selectedOption={selectedOption}
              onOptionChange={handleOptionChange}
            />
          </div>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div>
              <BulkRefresh
                selectedRows={selectedRows}
                api={api}
                selectedOption={selectedOption}
              />
            </div>
            <div>
              <MyScreenuserForm selectedOption={selectedOption} />
            </div>
          </div>
        </div>
        <div className="emms-main-container-left-align" style={{ marginLeft: "10%" }}>
          <Screenuser selectedOption={selectedOption} errors={errors} isLoading={isLoading} />
        </div>
      </div>
    </>
  );
}

export default ScreenuserDashboard;
